import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import { getQuizApi } from '../../../services/QuizService';
// import './quiz.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import UserQuizDetails from './UserQuiz/UserQuizDetails';
import AdminQuizParticipation from './AdminQuizParticipation';
import DisplayTopScorer from './DisplayTopScorer';
const QuizDetailsLoading = () => {
    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <div className="w-100 px-2 mt-3">
                        <Placeholder animation="glow">
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                        </Placeholder>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-item-center justify-content-between">
                        <div className="w-100 px-2">
                            <Placeholder animation="glow">
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                            </Placeholder>
                        </div>

                        <div className="w-100 px-2">
                            <Placeholder animation="glow">
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                            </Placeholder>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AdminQuizDetails = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [quiz, setQuiz] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchQuiz = async () => {
            setIsLoading(true);
            try {
                const response = await getQuizApi(id);
                const quizData = response.data.results;
                setQuiz(quizData);
            } catch (error) {
                toast.error("Error fetching quiz!");
            }
            setIsLoading(false);
        };

        fetchQuiz();
    }, [id]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-4">
                    {isLoading ? (
                        <QuizDetailsLoading />
                    ) : quiz !== null ? (
                        <div>
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <div className="d-flex align-items-center">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm btn-circle"
                                                onClick={() => navigate("/quiz")}
                                            >
                                                <i className="fa-solid fa-arrow-left"></i>
                                            </button>
                                            <h4 className="mb-0 ms-2">Quiz Details</h4>
                                        </div>
                                        {! quiz?.is_published &&
                                            <button
                                                className="btn btn-outline-primary btn-sm ms-1"
                                                onClick={() =>
                                                    navigate(`/edit-quiz/${quiz.id}`, {
                                                        state: { quizData: quiz },
                                                    })
                                                }
                                            >
                                                <i className="fa-solid fa-pen-to-square"></i> Edit
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div className="card-body"
                                    style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    {isLoading ? (
                                        <div>Loading...</div>
                                    ) : quiz?.questions?.length ? (
                                        <div>
                                            {quiz.is_result_published && <DisplayTopScorer quizId={quiz.id} />}

                                            {quiz.questions.map((question, index) => (
                                                <div key={question.id} className="mb-2">
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <h5 className="text-primary " style={{ fontSize: "12px" }}>
                                                            Question {question.question_number}:
                                                        </h5>
                                                    </div>
                                                    <p className="fs-5 text-black" dangerouslySetInnerHTML={{ __html: question.question_text }}></p>
                                                    <h5 className="text-black  mb-1" style={{ fontSize: "12px" }}>Options:</h5>
                                                    <ul className="list-group">
                                                        <li
                                                            className={
                                                                `list-group-item 
                                                            ${question.correct_option === "option_1" ? "bg-success text-white" : ""}`
                                                            }
                                                        >
                                                            A. {question.option_1}
                                                        </li>
                                                        <li
                                                            className={`list-group-item ${question.correct_option === "option_2"
                                                                ? "bg-success text-white"
                                                                : ""
                                                                }`}
                                                        >
                                                            B. {question.option_2}
                                                        </li>
                                                        <li
                                                            className={`list-group-item ${question.correct_option === "option_3"
                                                                ? "bg-success text-white"
                                                                : ""
                                                                }`}
                                                        >
                                                            C. {question.option_3}
                                                        </li>
                                                        <li
                                                            className={`list-group-item ${question.correct_option === "option_4"
                                                                ? "bg-success text-white"
                                                                : ""
                                                                }`}
                                                        >
                                                            D. {question.option_4}
                                                        </li>
                                                    </ul>
                                                    <h5 className="text-success mt-1" style={{ fontSize: "10px" }}>
                                                        Correct Answer: {question.correct_option === "option_1" && "A"}
                                                        {question.correct_option === "option_2" && "B"}
                                                        {question.correct_option === "option_3" && "C"}
                                                        {question.correct_option === "option_4" && "D"}
                                                    </h5>

                                                    <hr style={{ color: "black" }} />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center text-danger">
                                            ⚠️ No questions available for this quiz.
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* quiz details  */}

                            <div className="card">
                                <div className="card-body">
                                    <div className="action-group d-flex align-items-center justify-content-between">
                                        <span className='text-black text-bold'>
                                            Publish Status:
                                        </span>
                                        {quiz?.is_published ? (
                                            <span className="badge light border-0 badge-info badge-md">
                                                Publish
                                            </span>
                                        ) : (
                                            <span className="badge light border-0 badge-danger badge-md">
                                                Unpublish
                                            </span>
                                        )}
                                    </div>

                                    <div className="action-group d-flex align-items-center justify-content-between">
                                        <span className='text-black text-bold'>
                                            Publish Date:
                                        </span>
                                        <span className="">
                                            {quiz.publish_date}
                                        </span>
                                    </div>

                                    <div className="action-group d-flex align-items-center justify-content-between">
                                        <span className='text-black text-bold'>
                                            Quiz Duration:
                                        </span>
                                        <span className="">
                                            {quiz.start_time} - {quiz.end_time}
                                        </span>
                                    </div>

                                    <p><strong>Title:</strong> {quiz.title}</p>
                                    <p><strong>Description:</strong> {quiz.description}</p>

                                    <hr />
                                    <div className="action-group d-flex align-items-center justify-content-between mt-3">
                                        <span className='text-black'>Delete quiz</span>
                                        <button className="btn btn-sm btn-danger">Delete</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-center text-danger">
                                    ⚠️ Quiz Not Found!
                                    <br /> ID {id}
                                </h4>
                            </div>
                        </div>
                    )}
                </div>
                <div className="col-md-8">
                    <div className="card p-4 shadow-sm">
                        <div className="card-body p-0">
                            {quiz?.is_published ?
                                <AdminQuizParticipation quizId={quiz.id} />
                                : <h4 className='px-3'>Participant details are available once the quiz is published.</h4>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


const QuizDetails = ({ userRole }) => {

    return userRole === "SuperAdmin" ? <AdminQuizDetails /> : <UserQuizDetails />
};


const mapStateToProps = (state) => ({
    userRole: state.auth.user?.role || "User",
});

export default connect(mapStateToProps)(QuizDetails);


